import { render, staticRenderFns } from "./Examcopy.vue?vue&type=template&id=34781ace&"
import script from "./Examcopy.vue?vue&type=script&lang=js&"
export * from "./Examcopy.vue?vue&type=script&lang=js&"
import style0 from "./Examcopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports